<style lang="scss" scoped>
@import "../../style/color";
.coupon {
  .coupons {
    margin-top: 43px;
    &-ul {
      &-li:nth-child(2n + 2) {
        margin-right: 0;
      }
      &-li {
        width: 376px;
        margin-bottom: 10px;
        margin-right: 17px;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge */
        user-select: none;         /* 标准语法 */
        .item {
          width: 100%;
          padding: 14px 18px;
          box-sizing: border-box;
          background: #3199ca;
          // margin-bottom: 16px;
          box-sizing: border-box;
          border-radius: 15px;
          color: #ffffff;
          &.Unserviceable {
            background-color: #c6c6c6 !important;
            color: #fff !important;
            .Remark {
              color: #8d8b8b !important;
            }
            .shixiao {
              font-size: 16px;
              font-weight: bold;
              color: #ffffff;
            }
          }
          .Amount {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title {
              font-size: 28px;
              font-weight: 600;
              color: #ffffff;
              line-height: 1.1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .btn {
              padding: 4px 10px;
              background: #ffffff;
              border: 1px solid #000000;
              border-radius: 30px;
              color: #000;
              white-space: nowrap;
              font-size: 13px;
              font-weight: 600;
              cursor: pointer;
            }
          }

          .VoucherTitle {
            font-size: 13px;
            font-weight: 600;
            color: #ffffff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .Remark {
            font-size: 13px;
            font-weight: 600;
            min-height: 39px;
            @include ellipsisMore(2);
          }

          .btn_date {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .ok {
              .img {
                width: 67px;
                height: 67px;
                display: block;
              }
            }
            .date {
              font-size: 12px;
              color: #ffffff;
            }

            .btn {
              width: 112px;
              height: 26px;
              background: #ffffff;
              border-radius: 23px;
              text-align: center;
              line-height: 26px;
              font-size: 13px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="coupon">
    <div class="coupons">
      <ul class="coupons-ul clearfix">
        <li class="coupons-ul-li ovh fl" v-for="(item, index) in couponListColor" :key="index">
          <div class="item" :class="(item.Vstatus == 1 || item.Vstatus == 2 || item.Vstatus == 5) ? 'Unserviceable' : ''" :style="item.background">
            <div class="Amount">
              <div class="title">
                {{couponTitle(item)}}
              </div>
              <div class="btn" v-if="couponStyleType != 1 && item.Vstatus == 0" @click="ToCouponPage">
                {{$t("CouponVersion.CouponVersion30")}}
              </div>
            </div>
            <div class="VoucherTitle">
              {{item.VoucherTitle}}
            </div>
            <div class="Remark" :style="item.fountColor">
              {{item.Remark}}
            </div>
            <div class="btn_date">
              <div class="date">
                {{$t("coupon.validiy")}} : {{item.StartTime}} - {{item.EndTime}}
              </div>
              <div class="btn" :style="item.fountColor1" v-if="couponStyleType == 1 && item.Vstatus == 0" @click="GoToUse(item)">
                {{$t('coupon.ljshiyong')}}
              </div>
              <div class="shixiao" v-if="item.Vstatus == 5">
                {{$t("CouponVersion.CouponVersion31")}}
              </div>
              <div class="shixiao" v-else-if="item.Vstatus == 1">
                {{$t("CouponVersion.couponOverdue1")}}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import filter from "../../plugins/filters";
export default {
  name: "Newcoupon",
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: [],
    },
    couponStyleType: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    couponListColor() {
      this.list.forEach((item) => {
        if (item.CashType == 1) {
          item["background"] = "background:#6EBE58;";
          item["fountColor1"] = "color:#6EBE58;";
          item["fountColor"] = "color:#B1DCA5;";
        } else if (item.CashType == 2) {
          item["background"] = "background:#F07D00;";
          item["fountColor1"] = "color:#F07D00;";
          item["fountColor"] = "color:#FFBB75;";
        } else if (item.CashType == 3) {
          item["background"] = "background:#632C7E;";
          item["fountColor1"] = "color:#632C7E;";
          item["fountColor"] = "color:#B674D6;";
        } else if (item.CashType == 4) {
          item["background"] = "background:#3199CA;";
          item["fountColor1"] = "color:#3199CA;";
          item["fountColor"] = "color:#66C3EF;";
        }
      });
      return this.list;
    },
    lang: function () {
      return localStorage.getItem("lang")
        ? localStorage.getItem("lang")
        : this.$store.state.langType;
    },
  },
  methods: {
    // 券标题
    couponTitle(item) {
      if (item.CashType == 1) {
        if(this.lang == 1 || this.lang == 2){
						return `￥${item.DeductionMoney} OFF`;
					}else if(this.lang == 3){
						return  `¥${item.DeductionMoney} DE RÉDUCTION`
					}
      } else if (item.CashType == 2) {
        if (this.lang == 1) {
          return (
            (Number(item.DeductionMoney) * 100)
              .toFixed()
              .replace(/(0+)$/g, "") + "折"
          );
        } else if(this.lang == 2){
          return (
            100 - Math.floor(Number(item.DeductionMoney) * 100) + "%" + " OFF"
          );
        }else if(this.lang == 3){
          return "-" + (100 - Math.floor( Number(item.DeductionMoney) * 100 ))+"%";
        }
      } else if (item.CashType == 3) {
        if (this.lang == 1) {
          return `赠品`;
        } else if(this.lang == 2) {
          return `FREE`;
        } else if(this.lang == 3){
					return `OFFERT`;
				}
      } else if (item.CashType == 4) {
        if(this.lang == 1){
						return `优惠券`;
					}else if(this.lang == 2){
						return `LIMITED OFFER`;
					}else if(this.lang == 3){
						return `OFFRE LIMITÉE`;
					}
      }
    },
    GoToUse(item) {
      if (item.JunmpType == "index") {
        //首页
        this.$router.push("/index");
        this.$emit("HomePage")
      } else {
        this.$router.push({
          path: "/useCoupon",
          query: {
            CashVoucherCustomerID: item.CashVoucherCustomerID,
          },
        });
      }
    },
    //判断券的显示金额
    IfCoupon(couponList) {
      let text;
      if (couponList.CashType == 1) {
        text = "￥" + couponList.DeductionMoney;
      } else if (couponList.CashType == 2) {
        if (this.lang == 1) {
          text =
            (Number(couponList.DeductionMoney) * 100)
              .toFixed()
              .replace(/(0+)$/g, "") + "折";
        } else {
          text =
            100 -
            Math.floor(Number(couponList.DeductionMoney) * 100) +
            "%" +
            " OFF";
        }
      }
      return text;
    },
    ToCouponPage() {
      this.$router.push({
        path: "/user/coupon",
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/Newcoupon.vue